import { makeAutoObservable, runInAction } from "mobx";
import { showToast } from "@/lib/utils/toast";
import { surveysService } from "../services";

const resolvePayload = (payload) => {
  if (payload && typeof payload === "object" && "data" in payload) {
    return payload.data;
  }
  return payload;
};

class SurveyTakePageStore {
  survey = null;
  loading = false;
  error = "";

  surveyType = "";
  surveyId = "";
  token = "";
  inviteEmail = "";
  inviteName = "";
  inviteOrg = "";

  isAuthenticated = false;
  guestInfo = {
    name: "",
    email: "",
    organization: "",
  };

  constructor() {
    makeAutoObservable(this);
  }

  get guestInfoValid() {
    if (this.isAuthenticated) return true;
    return Boolean(
      this.guestInfo.name.trim() &&
      this.guestInfo.email.trim() &&
      this.guestInfo.organization.trim(),
    );
  }

  setParams = ({
    surveyType,
    surveyId,
    token,
    inviteEmail,
    inviteName,
    inviteOrg,
    isAuthenticated,
  }) => {
    this.surveyType = surveyType || "";
    this.surveyId = surveyId || "";
    this.token = token || "";
    this.inviteEmail = inviteEmail || "";
    this.inviteName = inviteName || "";
    this.inviteOrg = inviteOrg || "";
    this.isAuthenticated = Boolean(isAuthenticated);
    this.guestInfo = {
      name: this.inviteName,
      email: this.inviteEmail,
      organization: this.inviteOrg,
    };
  };

  setGuestField = (field, value) => {
    this.guestInfo = { ...this.guestInfo, [field]: value };
  };

  setError = (message) => {
    this.error = message || "";
  };

  clear = () => {
    this.survey = null;
    this.loading = false;
    this.error = "";
    this.token = "";
    this.surveyType = "";
    this.surveyId = "";
    this.inviteEmail = "";
    this.inviteName = "";
    this.inviteOrg = "";
    this.isAuthenticated = false;
    this.guestInfo = {
      name: "",
      email: "",
      organization: "",
    };
  };

  loadSurvey = async (t) => {
    if (!this.surveyId) return;
    if (!this.token) {
      this.error = t ? t("Share token is missing.") : "Share token is missing.";
      return;
    }

    runInAction(() => {
      this.loading = true;
      this.error = "";
    });

    try {
      const data = await surveysService.fetchSharedSurvey(
        this.surveyType,
        this.surveyId,
        {
          token: this.token,
          email: this.inviteEmail || undefined,
        },
      );

      const payload = resolvePayload(data) || {};
      runInAction(() => {
        this.survey = payload?.survey || null;
      });
    } catch (error) {
      const message =
        error?.message ||
        (t ? t("Unable to load survey.") : "Unable to load survey.");
      runInAction(() => {
        this.error = message;
      });
      showToast.error(message);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}

export const surveyTakePageStore = new SurveyTakePageStore();
